"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _footerLinks = _interopRequireDefault(require("../footerLinks/footerLinks"));

require("./globalFooter.css");

var _excluded = ["links", "copyrightText", "dataTestId"];

var GlobalFooter = function GlobalFooter(_ref) {
  var links = _ref.links,
      copyrightText = _ref.copyrightText,
      dataTestId = _ref.dataTestId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, "oui-global-footer-container")
  }, /*#__PURE__*/_react["default"].createElement(_footerLinks["default"], {
    links: links
  }), copyrightText && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "&copy;"
    }
  }), " ", copyrightText));
};

GlobalFooter.propTypes = {
  className: _propTypes["default"].string,
  copyrightText: _propTypes["default"].string,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    target: _propTypes["default"].oneOf(["_blank", "_self", "_parent", "_top"]),
    label: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string.isRequired,
    renderComponent: _propTypes["default"].func
  })),
  dataTestId: _propTypes["default"].string
};
GlobalFooter.defaultProps = {
  className: "",
  copyrightText: "",
  links: [],
  dataTestId: "orion-global-footer"
};
GlobalFooter.displayName = "OrionGlobalFooter";
var _default = GlobalFooter;
exports["default"] = _default;